module.exports = __webpack_public_path__ + "static/media/printer_drive.c1fc0be2.ico";